import React, { useState, useEffect } from 'react';

interface CountryOption {
  code: string;
  dialCode: string;
  name: string;
  flag: string;
  minLength: number;
  maxLength: number;
  format?: string;
}

// Comprehensive country data with validation rules - All countries
const COUNTRY_DATA: CountryOption[] = [
  // North America
  { code: 'US', dialCode: '+1', name: 'United States', flag: '🇺🇸', minLength: 10, maxLength: 10, format: '(XXX) XXX-XXXX' },
  { code: 'CA', dialCode: '+1', name: 'Canada', flag: '🇨🇦', minLength: 10, maxLength: 10, format: '(XXX) XXX-XXXX' },
  { code: 'MX', dialCode: '+52', name: 'Mexico', flag: '🇲🇽', minLength: 10, maxLength: 10 },
  
  // Europe - Western
  { code: 'GB', dialCode: '+44', name: 'United Kingdom', flag: '🇬🇧', minLength: 10, maxLength: 10 },
  { code: 'IE', dialCode: '+353', name: 'Ireland', flag: '🇮🇪', minLength: 9, maxLength: 9 },
  { code: 'FR', dialCode: '+33', name: 'France', flag: '🇫🇷', minLength: 9, maxLength: 9 },
  { code: 'DE', dialCode: '+49', name: 'Germany', flag: '🇩🇪', minLength: 10, maxLength: 11 },
  { code: 'ES', dialCode: '+34', name: 'Spain', flag: '🇪🇸', minLength: 9, maxLength: 9 },
  { code: 'IT', dialCode: '+39', name: 'Italy', flag: '🇮🇹', minLength: 9, maxLength: 10 },
  { code: 'NL', dialCode: '+31', name: 'Netherlands', flag: '🇳🇱', minLength: 9, maxLength: 9 },
  { code: 'BE', dialCode: '+32', name: 'Belgium', flag: '🇧🇪', minLength: 9, maxLength: 9 },
  { code: 'LU', dialCode: '+352', name: 'Luxembourg', flag: '🇱🇺', minLength: 9, maxLength: 9 },
  { code: 'CH', dialCode: '+41', name: 'Switzerland', flag: '🇨🇭', minLength: 9, maxLength: 9 },
  { code: 'AT', dialCode: '+43', name: 'Austria', flag: '🇦🇹', minLength: 10, maxLength: 13 },
  { code: 'PT', dialCode: '+351', name: 'Portugal', flag: '🇵🇹', minLength: 9, maxLength: 9 },
  
  // Europe - Nordic
  { code: 'SE', dialCode: '+46', name: 'Sweden', flag: '🇸🇪', minLength: 9, maxLength: 9 },
  { code: 'NO', dialCode: '+47', name: 'Norway', flag: '🇳🇴', minLength: 8, maxLength: 8 },
  { code: 'DK', dialCode: '+45', name: 'Denmark', flag: '🇩🇰', minLength: 8, maxLength: 8 },
  { code: 'FI', dialCode: '+358', name: 'Finland', flag: '🇫🇮', minLength: 9, maxLength: 10 },
  { code: 'IS', dialCode: '+354', name: 'Iceland', flag: '🇮🇸', minLength: 7, maxLength: 7 },
  
  // Europe - Eastern
  { code: 'PL', dialCode: '+48', name: 'Poland', flag: '🇵🇱', minLength: 9, maxLength: 9 },
  { code: 'CZ', dialCode: '+420', name: 'Czech Republic', flag: '🇨🇿', minLength: 9, maxLength: 9 },
  { code: 'SK', dialCode: '+421', name: 'Slovakia', flag: '🇸🇰', minLength: 9, maxLength: 9 },
  { code: 'HU', dialCode: '+36', name: 'Hungary', flag: '🇭🇺', minLength: 9, maxLength: 9 },
  { code: 'RO', dialCode: '+40', name: 'Romania', flag: '🇷🇴', minLength: 9, maxLength: 9 },
  { code: 'BG', dialCode: '+359', name: 'Bulgaria', flag: '🇧🇬', minLength: 9, maxLength: 9 },
  { code: 'HR', dialCode: '+385', name: 'Croatia', flag: '🇭🇷', minLength: 9, maxLength: 9 },
  { code: 'SI', dialCode: '+386', name: 'Slovenia', flag: '🇸🇮', minLength: 8, maxLength: 8 },
  { code: 'RS', dialCode: '+381', name: 'Serbia', flag: '🇷🇸', minLength: 8, maxLength: 9 },
  { code: 'BA', dialCode: '+387', name: 'Bosnia and Herzegovina', flag: '🇧🇦', minLength: 8, maxLength: 8 },
  { code: 'ME', dialCode: '+382', name: 'Montenegro', flag: '🇲🇪', minLength: 8, maxLength: 8 },
  { code: 'MK', dialCode: '+389', name: 'North Macedonia', flag: '🇲🇰', minLength: 8, maxLength: 8 },
  { code: 'AL', dialCode: '+355', name: 'Albania', flag: '🇦🇱', minLength: 9, maxLength: 9 },
  { code: 'XK', dialCode: '+383', name: 'Kosovo', flag: '🇽🇰', minLength: 8, maxLength: 8 },
  { code: 'UA', dialCode: '+380', name: 'Ukraine', flag: '🇺🇦', minLength: 9, maxLength: 9 },
  { code: 'BY', dialCode: '+375', name: 'Belarus', flag: '🇧🇾', minLength: 9, maxLength: 9 },
  { code: 'MD', dialCode: '+373', name: 'Moldova', flag: '🇲🇩', minLength: 8, maxLength: 8 },
  { code: 'RU', dialCode: '+7', name: 'Russia', flag: '🇷🇺', minLength: 10, maxLength: 10 },
  { code: 'EE', dialCode: '+372', name: 'Estonia', flag: '🇪🇪', minLength: 7, maxLength: 8 },
  { code: 'LV', dialCode: '+371', name: 'Latvia', flag: '🇱🇻', minLength: 8, maxLength: 8 },
  { code: 'LT', dialCode: '+370', name: 'Lithuania', flag: '🇱🇹', minLength: 8, maxLength: 8 },
  
  // Europe - Southern
  { code: 'GR', dialCode: '+30', name: 'Greece', flag: '🇬🇷', minLength: 10, maxLength: 10 },
  { code: 'CY', dialCode: '+357', name: 'Cyprus', flag: '🇨🇾', minLength: 8, maxLength: 8 },
  { code: 'MT', dialCode: '+356', name: 'Malta', flag: '🇲🇹', minLength: 8, maxLength: 8 },
  
  // Asia - East
  { code: 'CN', dialCode: '+86', name: 'China', flag: '🇨🇳', minLength: 11, maxLength: 11 },
  { code: 'JP', dialCode: '+81', name: 'Japan', flag: '🇯🇵', minLength: 10, maxLength: 10 },
  { code: 'KR', dialCode: '+82', name: 'South Korea', flag: '🇰🇷', minLength: 9, maxLength: 10 },
  { code: 'KP', dialCode: '+850', name: 'North Korea', flag: '🇰🇵', minLength: 9, maxLength: 10 },
  { code: 'HK', dialCode: '+852', name: 'Hong Kong', flag: '🇭🇰', minLength: 8, maxLength: 8 },
  { code: 'MO', dialCode: '+853', name: 'Macau', flag: '🇲🇴', minLength: 8, maxLength: 8 },
  { code: 'TW', dialCode: '+886', name: 'Taiwan', flag: '🇹🇼', minLength: 9, maxLength: 9 },
  { code: 'MN', dialCode: '+976', name: 'Mongolia', flag: '🇲🇳', minLength: 8, maxLength: 8 },
  
  // Asia - Southeast
  { code: 'SG', dialCode: '+65', name: 'Singapore', flag: '🇸🇬', minLength: 8, maxLength: 8 },
  { code: 'MY', dialCode: '+60', name: 'Malaysia', flag: '🇲🇾', minLength: 9, maxLength: 10 },
  { code: 'TH', dialCode: '+66', name: 'Thailand', flag: '🇹🇭', minLength: 9, maxLength: 9 },
  { code: 'PH', dialCode: '+63', name: 'Philippines', flag: '🇵🇭', minLength: 10, maxLength: 10 },
  { code: 'ID', dialCode: '+62', name: 'Indonesia', flag: '🇮🇩', minLength: 10, maxLength: 12 },
  { code: 'VN', dialCode: '+84', name: 'Vietnam', flag: '🇻🇳', minLength: 9, maxLength: 10 },
  { code: 'LA', dialCode: '+856', name: 'Laos', flag: '🇱🇦', minLength: 9, maxLength: 10 },
  { code: 'KH', dialCode: '+855', name: 'Cambodia', flag: '🇰🇭', minLength: 8, maxLength: 9 },
  { code: 'MM', dialCode: '+95', name: 'Myanmar', flag: '🇲🇲', minLength: 8, maxLength: 10 },
  { code: 'BN', dialCode: '+673', name: 'Brunei', flag: '🇧🇳', minLength: 7, maxLength: 7 },
  { code: 'TL', dialCode: '+670', name: 'East Timor', flag: '🇹🇱', minLength: 7, maxLength: 7 },
  
  // Asia - South
  { code: 'IN', dialCode: '+91', name: 'India', flag: '🇮🇳', minLength: 10, maxLength: 10 },
  { code: 'PK', dialCode: '+92', name: 'Pakistan', flag: '🇵🇰', minLength: 10, maxLength: 10 },
  { code: 'BD', dialCode: '+880', name: 'Bangladesh', flag: '🇧🇩', minLength: 10, maxLength: 10 },
  { code: 'LK', dialCode: '+94', name: 'Sri Lanka', flag: '🇱🇰', minLength: 9, maxLength: 9 },
  { code: 'NP', dialCode: '+977', name: 'Nepal', flag: '🇳🇵', minLength: 10, maxLength: 10 },
  { code: 'BT', dialCode: '+975', name: 'Bhutan', flag: '🇧🇹', minLength: 8, maxLength: 8 },
  { code: 'MV', dialCode: '+960', name: 'Maldives', flag: '🇲🇻', minLength: 7, maxLength: 7 },
  { code: 'AF', dialCode: '+93', name: 'Afghanistan', flag: '🇦🇫', minLength: 9, maxLength: 9 },
  
  // Asia - Central
  { code: 'KZ', dialCode: '+7', name: 'Kazakhstan', flag: '🇰🇿', minLength: 10, maxLength: 10 },
  { code: 'UZ', dialCode: '+998', name: 'Uzbekistan', flag: '🇺🇿', minLength: 9, maxLength: 9 },
  { code: 'TM', dialCode: '+993', name: 'Turkmenistan', flag: '🇹🇲', minLength: 8, maxLength: 8 },
  { code: 'KG', dialCode: '+996', name: 'Kyrgyzstan', flag: '🇰🇬', minLength: 9, maxLength: 9 },
  { code: 'TJ', dialCode: '+992', name: 'Tajikistan', flag: '🇹🇯', minLength: 9, maxLength: 9 },
  
  // Middle East
  { code: 'TR', dialCode: '+90', name: 'Turkey', flag: '🇹🇷', minLength: 10, maxLength: 10 },
  { code: 'AE', dialCode: '+971', name: 'United Arab Emirates', flag: '🇦🇪', minLength: 9, maxLength: 9 },
  { code: 'SA', dialCode: '+966', name: 'Saudi Arabia', flag: '🇸🇦', minLength: 9, maxLength: 9 },
  { code: 'PS', dialCode: '+970', name: 'Palestine', flag: '🇵🇸', minLength: 9, maxLength: 9 },
  { code: 'JO', dialCode: '+962', name: 'Jordan', flag: '🇯🇴', minLength: 9, maxLength: 9 },
  { code: 'LB', dialCode: '+961', name: 'Lebanon', flag: '🇱🇧', minLength: 7, maxLength: 8 },
  { code: 'SY', dialCode: '+963', name: 'Syria', flag: '🇸🇾', minLength: 9, maxLength: 9 },
  { code: 'IQ', dialCode: '+964', name: 'Iraq', flag: '🇮🇶', minLength: 10, maxLength: 10 },
  { code: 'IR', dialCode: '+98', name: 'Iran', flag: '🇮🇷', minLength: 10, maxLength: 10 },
  { code: 'KW', dialCode: '+965', name: 'Kuwait', flag: '🇰🇼', minLength: 8, maxLength: 8 },
  { code: 'BH', dialCode: '+973', name: 'Bahrain', flag: '🇧🇭', minLength: 8, maxLength: 8 },
  { code: 'QA', dialCode: '+974', name: 'Qatar', flag: '🇶🇦', minLength: 8, maxLength: 8 },
  { code: 'OM', dialCode: '+968', name: 'Oman', flag: '🇴🇲', minLength: 8, maxLength: 8 },
  { code: 'YE', dialCode: '+967', name: 'Yemen', flag: '🇾🇪', minLength: 9, maxLength: 9 },
  { code: 'AM', dialCode: '+374', name: 'Armenia', flag: '🇦🇲', minLength: 8, maxLength: 8 },
  { code: 'AZ', dialCode: '+994', name: 'Azerbaijan', flag: '🇦🇿', minLength: 9, maxLength: 9 },
  { code: 'GE', dialCode: '+995', name: 'Georgia', flag: '🇬🇪', minLength: 9, maxLength: 9 },
  
  // Africa - North
  { code: 'EG', dialCode: '+20', name: 'Egypt', flag: '🇪🇬', minLength: 10, maxLength: 10 },
  { code: 'LY', dialCode: '+218', name: 'Libya', flag: '🇱🇾', minLength: 9, maxLength: 10 },
  { code: 'TN', dialCode: '+216', name: 'Tunisia', flag: '🇹🇳', minLength: 8, maxLength: 8 },
  { code: 'DZ', dialCode: '+213', name: 'Algeria', flag: '🇩🇿', minLength: 9, maxLength: 9 },
  { code: 'MA', dialCode: '+212', name: 'Morocco', flag: '🇲🇦', minLength: 9, maxLength: 9 },
  { code: 'SD', dialCode: '+249', name: 'Sudan', flag: '🇸🇩', minLength: 9, maxLength: 9 },
  { code: 'SS', dialCode: '+211', name: 'South Sudan', flag: '🇸🇸', minLength: 9, maxLength: 9 },
  
  // Africa - West
  { code: 'NG', dialCode: '+234', name: 'Nigeria', flag: '🇳🇬', minLength: 10, maxLength: 10 },
  { code: 'GH', dialCode: '+233', name: 'Ghana', flag: '🇬🇭', minLength: 9, maxLength: 9 },
  { code: 'CI', dialCode: '+225', name: 'Ivory Coast', flag: '🇨🇮', minLength: 10, maxLength: 10 },
  { code: 'SN', dialCode: '+221', name: 'Senegal', flag: '🇸🇳', minLength: 9, maxLength: 9 },
  { code: 'ML', dialCode: '+223', name: 'Mali', flag: '🇲🇱', minLength: 8, maxLength: 8 },
  { code: 'NE', dialCode: '+227', name: 'Niger', flag: '🇳🇪', minLength: 8, maxLength: 8 },
  { code: 'BF', dialCode: '+226', name: 'Burkina Faso', flag: '🇧🇫', minLength: 8, maxLength: 8 },
  { code: 'BJ', dialCode: '+229', name: 'Benin', flag: '🇧🇯', minLength: 8, maxLength: 8 },
  { code: 'TG', dialCode: '+228', name: 'Togo', flag: '🇹🇬', minLength: 8, maxLength: 8 },
  { code: 'GM', dialCode: '+220', name: 'Gambia', flag: '🇬🇲', minLength: 7, maxLength: 7 },
  { code: 'GW', dialCode: '+245', name: 'Guinea-Bissau', flag: '🇬🇼', minLength: 7, maxLength: 7 },
  { code: 'GN', dialCode: '+224', name: 'Guinea', flag: '🇬🇳', minLength: 9, maxLength: 9 },
  { code: 'SL', dialCode: '+232', name: 'Sierra Leone', flag: '🇸🇱', minLength: 8, maxLength: 8 },
  { code: 'LR', dialCode: '+231', name: 'Liberia', flag: '🇱🇷', minLength: 7, maxLength: 8 },
  { code: 'MR', dialCode: '+222', name: 'Mauritania', flag: '🇲🇷', minLength: 8, maxLength: 8 },
  { code: 'CV', dialCode: '+238', name: 'Cape Verde', flag: '🇨🇻', minLength: 7, maxLength: 7 },
  
  // Africa - Central
  { code: 'CM', dialCode: '+237', name: 'Cameroon', flag: '🇨🇲', minLength: 9, maxLength: 9 },
  { code: 'TD', dialCode: '+235', name: 'Chad', flag: '🇹🇩', minLength: 8, maxLength: 8 },
  { code: 'CF', dialCode: '+236', name: 'Central African Republic', flag: '🇨🇫', minLength: 8, maxLength: 8 },
  { code: 'CG', dialCode: '+242', name: 'Congo', flag: '🇨🇬', minLength: 9, maxLength: 9 },
  { code: 'CD', dialCode: '+243', name: 'DR Congo', flag: '🇨🇩', minLength: 9, maxLength: 9 },
  { code: 'GA', dialCode: '+241', name: 'Gabon', flag: '🇬🇦', minLength: 7, maxLength: 7 },
  { code: 'GQ', dialCode: '+240', name: 'Equatorial Guinea', flag: '🇬🇶', minLength: 9, maxLength: 9 },
  { code: 'ST', dialCode: '+239', name: 'São Tomé and Príncipe', flag: '🇸🇹', minLength: 7, maxLength: 7 },
  
  // Africa - East
  { code: 'KE', dialCode: '+254', name: 'Kenya', flag: '🇰🇪', minLength: 9, maxLength: 10 },
  { code: 'TZ', dialCode: '+255', name: 'Tanzania', flag: '🇹🇿', minLength: 9, maxLength: 9 },
  { code: 'UG', dialCode: '+256', name: 'Uganda', flag: '🇺🇬', minLength: 9, maxLength: 9 },
  { code: 'RW', dialCode: '+250', name: 'Rwanda', flag: '🇷🇼', minLength: 9, maxLength: 9 },
  { code: 'BI', dialCode: '+257', name: 'Burundi', flag: '🇧🇮', minLength: 8, maxLength: 8 },
  { code: 'ET', dialCode: '+251', name: 'Ethiopia', flag: '🇪🇹', minLength: 9, maxLength: 9 },
  { code: 'ER', dialCode: '+291', name: 'Eritrea', flag: '🇪🇷', minLength: 7, maxLength: 7 },
  { code: 'DJ', dialCode: '+253', name: 'Djibouti', flag: '🇩🇯', minLength: 8, maxLength: 8 },
  { code: 'SO', dialCode: '+252', name: 'Somalia', flag: '🇸🇴', minLength: 8, maxLength: 9 },
  { code: 'MU', dialCode: '+230', name: 'Mauritius', flag: '🇲🇺', minLength: 8, maxLength: 8 },
  { code: 'SC', dialCode: '+248', name: 'Seychelles', flag: '🇸🇨', minLength: 7, maxLength: 7 },
  { code: 'KM', dialCode: '+269', name: 'Comoros', flag: '🇰🇲', minLength: 7, maxLength: 7 },
  { code: 'MG', dialCode: '+261', name: 'Madagascar', flag: '🇲🇬', minLength: 9, maxLength: 10 },
  
  // Africa - Southern
  { code: 'ZA', dialCode: '+27', name: 'South Africa', flag: '🇿🇦', minLength: 9, maxLength: 9 },
  { code: 'NA', dialCode: '+264', name: 'Namibia', flag: '🇳🇦', minLength: 9, maxLength: 10 },
  { code: 'BW', dialCode: '+267', name: 'Botswana', flag: '🇧🇼', minLength: 8, maxLength: 8 },
  { code: 'ZW', dialCode: '+263', name: 'Zimbabwe', flag: '🇿🇼', minLength: 9, maxLength: 9 },
  { code: 'ZM', dialCode: '+260', name: 'Zambia', flag: '🇿🇲', minLength: 9, maxLength: 9 },
  { code: 'MW', dialCode: '+265', name: 'Malawi', flag: '🇲🇼', minLength: 8, maxLength: 9 },
  { code: 'MZ', dialCode: '+258', name: 'Mozambique', flag: '🇲🇿', minLength: 9, maxLength: 9 },
  { code: 'AO', dialCode: '+244', name: 'Angola', flag: '🇦🇴', minLength: 9, maxLength: 9 },
  { code: 'LS', dialCode: '+266', name: 'Lesotho', flag: '🇱🇸', minLength: 8, maxLength: 8 },
  { code: 'SZ', dialCode: '+268', name: 'Eswatini', flag: '🇸🇿', minLength: 8, maxLength: 8 },
  
  // Oceania
  { code: 'AU', dialCode: '+61', name: 'Australia', flag: '🇦🇺', minLength: 9, maxLength: 9 },
  { code: 'NZ', dialCode: '+64', name: 'New Zealand', flag: '🇳🇿', minLength: 8, maxLength: 10 },
  { code: 'PG', dialCode: '+675', name: 'Papua New Guinea', flag: '🇵🇬', minLength: 8, maxLength: 8 },
  { code: 'FJ', dialCode: '+679', name: 'Fiji', flag: '🇫🇯', minLength: 7, maxLength: 7 },
  { code: 'SB', dialCode: '+677', name: 'Solomon Islands', flag: '🇸🇧', minLength: 7, maxLength: 7 },
  { code: 'VU', dialCode: '+678', name: 'Vanuatu', flag: '🇻🇺', minLength: 7, maxLength: 7 },
  { code: 'NC', dialCode: '+687', name: 'New Caledonia', flag: '🇳🇨', minLength: 6, maxLength: 6 },
  { code: 'PF', dialCode: '+689', name: 'French Polynesia', flag: '🇵🇫', minLength: 8, maxLength: 8 },
  { code: 'WS', dialCode: '+685', name: 'Samoa', flag: '🇼🇸', minLength: 7, maxLength: 7 },
  { code: 'TO', dialCode: '+676', name: 'Tonga', flag: '🇹🇴', minLength: 5, maxLength: 7 },
  { code: 'KI', dialCode: '+686', name: 'Kiribati', flag: '🇰🇮', minLength: 8, maxLength: 8 },
  { code: 'TV', dialCode: '+688', name: 'Tuvalu', flag: '🇹🇻', minLength: 6, maxLength: 6 },
  { code: 'NR', dialCode: '+674', name: 'Nauru', flag: '🇳🇷', minLength: 7, maxLength: 7 },
  { code: 'PW', dialCode: '+680', name: 'Palau', flag: '🇵🇼', minLength: 7, maxLength: 7 },
  { code: 'FM', dialCode: '+691', name: 'Micronesia', flag: '🇫🇲', minLength: 7, maxLength: 7 },
  { code: 'MH', dialCode: '+692', name: 'Marshall Islands', flag: '🇲🇭', minLength: 7, maxLength: 7 },
  
  // South America
  { code: 'BR', dialCode: '+55', name: 'Brazil', flag: '🇧🇷', minLength: 10, maxLength: 11 },
  { code: 'AR', dialCode: '+54', name: 'Argentina', flag: '🇦🇷', minLength: 10, maxLength: 10 },
  { code: 'CL', dialCode: '+56', name: 'Chile', flag: '🇨🇱', minLength: 9, maxLength: 9 },
  { code: 'CO', dialCode: '+57', name: 'Colombia', flag: '🇨🇴', minLength: 10, maxLength: 10 },
  { code: 'PE', dialCode: '+51', name: 'Peru', flag: '🇵🇪', minLength: 9, maxLength: 9 },
  { code: 'VE', dialCode: '+58', name: 'Venezuela', flag: '🇻🇪', minLength: 10, maxLength: 10 },
  { code: 'EC', dialCode: '+593', name: 'Ecuador', flag: '🇪🇨', minLength: 9, maxLength: 9 },
  { code: 'BO', dialCode: '+591', name: 'Bolivia', flag: '🇧🇴', minLength: 8, maxLength: 8 },
  { code: 'PY', dialCode: '+595', name: 'Paraguay', flag: '🇵🇾', minLength: 9, maxLength: 9 },
  { code: 'UY', dialCode: '+598', name: 'Uruguay', flag: '🇺🇾', minLength: 8, maxLength: 8 },
  { code: 'GY', dialCode: '+592', name: 'Guyana', flag: '🇬🇾', minLength: 7, maxLength: 7 },
  { code: 'SR', dialCode: '+597', name: 'Suriname', flag: '🇸🇷', minLength: 7, maxLength: 7 },
  { code: 'GF', dialCode: '+594', name: 'French Guiana', flag: '🇬🇫', minLength: 9, maxLength: 9 },
  
  // Central America & Caribbean
  { code: 'GT', dialCode: '+502', name: 'Guatemala', flag: '🇬🇹', minLength: 8, maxLength: 8 },
  { code: 'HN', dialCode: '+504', name: 'Honduras', flag: '🇭🇳', minLength: 8, maxLength: 8 },
  { code: 'SV', dialCode: '+503', name: 'El Salvador', flag: '🇸🇻', minLength: 8, maxLength: 8 },
  { code: 'NI', dialCode: '+505', name: 'Nicaragua', flag: '🇳🇮', minLength: 8, maxLength: 8 },
  { code: 'CR', dialCode: '+506', name: 'Costa Rica', flag: '🇨🇷', minLength: 8, maxLength: 8 },
  { code: 'PA', dialCode: '+507', name: 'Panama', flag: '🇵🇦', minLength: 8, maxLength: 8 },
  { code: 'BZ', dialCode: '+501', name: 'Belize', flag: '🇧🇿', minLength: 7, maxLength: 7 },
  { code: 'CU', dialCode: '+53', name: 'Cuba', flag: '🇨🇺', minLength: 8, maxLength: 8 },
  { code: 'JM', dialCode: '+1', name: 'Jamaica', flag: '🇯🇲', minLength: 10, maxLength: 10 },
  { code: 'HT', dialCode: '+509', name: 'Haiti', flag: '🇭🇹', minLength: 8, maxLength: 8 },
  { code: 'DO', dialCode: '+1', name: 'Dominican Republic', flag: '🇩🇴', minLength: 10, maxLength: 10 },
  { code: 'PR', dialCode: '+1', name: 'Puerto Rico', flag: '🇵🇷', minLength: 10, maxLength: 10 },
  { code: 'TT', dialCode: '+1', name: 'Trinidad and Tobago', flag: '🇹🇹', minLength: 10, maxLength: 10 },
  { code: 'BS', dialCode: '+1', name: 'Bahamas', flag: '🇧🇸', minLength: 10, maxLength: 10 },
  { code: 'BB', dialCode: '+1', name: 'Barbados', flag: '🇧🇧', minLength: 10, maxLength: 10 },
  { code: 'LC', dialCode: '+1', name: 'Saint Lucia', flag: '🇱🇨', minLength: 10, maxLength: 10 },
  { code: 'GD', dialCode: '+1', name: 'Grenada', flag: '🇬🇩', minLength: 10, maxLength: 10 },
  { code: 'VC', dialCode: '+1', name: 'Saint Vincent', flag: '🇻🇨', minLength: 10, maxLength: 10 },
  { code: 'AG', dialCode: '+1', name: 'Antigua and Barbuda', flag: '🇦🇬', minLength: 10, maxLength: 10 },
  { code: 'DM', dialCode: '+1', name: 'Dominica', flag: '🇩🇲', minLength: 10, maxLength: 10 },
  { code: 'KN', dialCode: '+1', name: 'Saint Kitts and Nevis', flag: '🇰🇳', minLength: 10, maxLength: 10 },
];

interface PhoneNumberInputProps {
  value: string;
  onChange: (formattedNumber: string, isValid: boolean) => void;
  defaultCountryCode?: string;
  theme: any;
  disabled?: boolean;
  placeholder?: string;
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  value,
  onChange,
  defaultCountryCode = 'GB',
  theme,
  disabled = false,
  placeholder = 'Enter phone number'
}) => {
  const [selectedCountry, setSelectedCountry] = useState<CountryOption | null>(null);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [showParseHint, setShowParseHint] = useState(false);

  // Initialize with default country
  useEffect(() => {
    const country = COUNTRY_DATA.find(c => c.code === defaultCountryCode) || COUNTRY_DATA[0];
    setSelectedCountry(country);
  }, [defaultCountryCode]);

  // Parse existing value when component mounts or value changes externally
  useEffect(() => {
    if (value && value.startsWith('+')) {
      // Try to parse the country code from the value
      for (const country of COUNTRY_DATA) {
        if (value.startsWith(country.dialCode)) {
          setSelectedCountry(country);
          setPhoneNumber(value.substring(country.dialCode.length));
          break;
        }
      }
    }
  }, []);

  // Validate phone number based on selected country
  const validatePhoneNumber = (parsedDigits: string, country: CountryOption): boolean => {
    if (!parsedDigits) return false;
    
    const length = parsedDigits.length;
    return length >= country.minLength && length <= country.maxLength;
  };

  // Parse and normalize phone number based on country-specific rules
  const parsePhoneNumber = (input: string, country: CountryOption): { digits: string; wasModified: boolean } => {
    let digitsOnly = input.replace(/\D/g, '');
    const original = digitsOnly;
    let wasModified = false;
    
    // Country-specific parsing rules
    switch (country.code) {
      // UK - Remove leading 0
      case 'GB':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // France - Remove leading 0
      case 'FR':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Italy - Remove leading 0
      case 'IT':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Spain - Remove leading 0 or 34 (country code)
      case 'ES':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        } else if (digitsOnly.startsWith('34')) {
          digitsOnly = digitsOnly.substring(2);
          wasModified = true;
        }
        break;
      
      // Germany - Remove leading 0
      case 'DE':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Netherlands - Remove leading 0
      case 'NL':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Belgium - Remove leading 0
      case 'BE':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Switzerland - Remove leading 0
      case 'CH':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Austria - Remove leading 0
      case 'AT':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Sweden - Remove leading 0
      case 'SE':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Norway - Remove leading 0 (though less common)
      case 'NO':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Denmark - Remove leading 0 (though less common)
      case 'DK':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Finland - Remove leading 0
      case 'FI':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Poland - Remove leading 0
      case 'PL':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Ireland - Remove leading 0
      case 'IE':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Portugal - Remove leading 0
      case 'PT':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Australia - Remove leading 0
      case 'AU':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // New Zealand - Remove leading 0
      case 'NZ':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Argentina - Remove leading 0 or 15
      case 'AR':
        if (digitsOnly.startsWith('15')) {
          digitsOnly = digitsOnly.substring(2);
          wasModified = true;
        } else if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Brazil - Remove leading 0
      case 'BR':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // India - Remove leading 0
      case 'IN':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // South Africa - Remove leading 0
      case 'ZA':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Israel - Remove leading 0
      case 'IL':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Turkey - Remove leading 0
      case 'TR':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Russia/Kazakhstan - Remove leading 8 or 0
      case 'RU':
      case 'KZ':
        if (digitsOnly.startsWith('8')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        } else if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Egypt - Remove leading 0
      case 'EG':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Nigeria - Remove leading 0
      case 'NG':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Kenya - Remove leading 0
      case 'KE':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Ghana - Remove leading 0
      case 'GH':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Thailand - Remove leading 0
      case 'TH':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Malaysia - Remove leading 0
      case 'MY':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Indonesia - Remove leading 0
      case 'ID':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Vietnam - Remove leading 0
      case 'VN':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Philippines - Remove leading 0
      case 'PH':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Pakistan - Remove leading 0
      case 'PK':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Bangladesh - Remove leading 0
      case 'BD':
        if (digitsOnly.startsWith('0')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // US/Canada - Remove leading 1 if present (country code duplicate)
      case 'US':
      case 'CA':
      case 'JM':
      case 'DO':
      case 'PR':
      case 'TT':
      case 'BS':
      case 'BB':
        if (digitsOnly.length === 11 && digitsOnly.startsWith('1')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        }
        break;
      
      // Mexico - Remove leading 1 if it's 11 digits
      case 'MX':
        if (digitsOnly.length === 11 && digitsOnly.startsWith('1')) {
          digitsOnly = digitsOnly.substring(1);
          wasModified = true;
        } else if (digitsOnly.startsWith('52') && digitsOnly.length === 12) {
          digitsOnly = digitsOnly.substring(2);
          wasModified = true;
        }
        break;
      
      // For most other countries, no special parsing needed
      default:
        break;
    }
    
    return { digits: digitsOnly, wasModified };
  };

  // Handle phone number input change
  const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    // Allow only digits, spaces, dashes, and parentheses
    const sanitized = input.replace(/[^\d\s\-()]/g, '');
    
    setPhoneNumber(sanitized);
    
    if (selectedCountry) {
      const { digits: parsedDigits, wasModified } = parsePhoneNumber(sanitized, selectedCountry);
      setShowParseHint(wasModified && parsedDigits.length > 0);
      const fullNumber = selectedCountry.dialCode + parsedDigits;
      const isValid = validatePhoneNumber(parsedDigits, selectedCountry);
      onChange(fullNumber, isValid);
      
      // Auto-hide the hint after 3 seconds
      if (wasModified) {
        setTimeout(() => setShowParseHint(false), 3000);
      }
    }
  };

  // Handle country selection
  const handleCountrySelect = (country: CountryOption) => {
    setSelectedCountry(country);
    setIsDropdownOpen(false);
    setSearchTerm('');
    
    // Recalculate validation with new country
    if (phoneNumber) {
      const { digits: parsedDigits } = parsePhoneNumber(phoneNumber, country);
      const fullNumber = country.dialCode + parsedDigits;
      const isValid = validatePhoneNumber(parsedDigits, country);
      onChange(fullNumber, isValid);
    }
  };

  // Get hint text for the selected country
  const getHintText = (country: CountryOption | null): string => {
    if (!country) return '';
    
    const lengthInfo = country.minLength !== country.maxLength 
      ? `${country.minLength}-${country.maxLength} digits`
      : `${country.minLength} digits`;
    
    // Countries where leading 0 should be omitted
    const leadingZeroCountries = [
      'GB', 'FR', 'IT', 'ES', 'DE', 'NL', 'BE', 'CH', 'AT', 'SE', 'NO', 'DK', 
      'FI', 'PL', 'IE', 'PT', 'AU', 'NZ', 'BR', 'IN', 'ZA', 'IL', 'TR', 'EG', 
      'NG', 'KE', 'GH', 'TH', 'MY', 'ID', 'VN', 'PH', 'PK', 'BD'
    ];
    
    if (leadingZeroCountries.includes(country.code)) {
      return `${lengthInfo}`;
    }
    
    if (country.code === 'AR') {
      return `${lengthInfo}`;
    }
    
    if (['RU', 'KZ'].includes(country.code)) {
      return `${lengthInfo}`;
    }
    
    if (['US', 'CA', 'JM', 'DO', 'PR', 'TT', 'BS', 'BB'].includes(country.code)) {
      return `${lengthInfo}`;
    }
    
    if (country.format) {
      return `Format: ${country.format}`;
    }
    
    return lengthInfo;
  };

  // Filter countries based on search
  const filteredCountries = COUNTRY_DATA.filter(country =>
    country.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    country.dialCode.includes(searchTerm) ||
    country.code.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '4px',
      position: 'relative' as const,
    },
    inputContainer: {
      display: 'flex',
      alignItems: 'center',
      border: `1px solid ${theme.searchBarColor || '#e1e1e1'}`,
      borderRadius: '10px',
      overflow: 'hidden',
      background: theme.searchBarColor || 'none',
    },
    countrySelector: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      padding: '0 12px',
      cursor: disabled ? 'not-allowed' : 'pointer',
      borderRight: `1px solid ${theme.searchBarColor || '#e1e1e1'}`,
      minWidth: '100px',
      height: '36px',
      backgroundColor: disabled ? '#f5f5f5' : 'transparent',
    },
    flag: {
      fontSize: '20px',
    },
    dialCode: {
      fontSize: '16px',
      color: theme.cartTextColor,
      fontWeight: '500',
    },
    dropdownArrow: {
      fontSize: '12px',
      color: theme.cartTextColor,
      marginLeft: 'auto',
    },
    input: {
      flex: 1,
      height: '36px',
      padding: '0 12px',
      border: 'none',
      background: 'transparent',
      color: theme.cartTextColor,
      fontSize: '16px',
      outline: 'none',
    },
    dropdown: {
      position: 'absolute' as const,
      top: '100%',
      left: 0,
      right: 0,
      marginTop: '4px',
      backgroundColor: theme.backgroundColor || '#ffffff',
      border: `1px solid ${theme.searchBarColor || '#e1e1e1'}`,
      borderRadius: '10px',
      maxHeight: '300px',
      overflowY: 'auto' as const,
      zIndex: 1000,
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    },
    searchInput: {
      width: '100%',
      padding: '12px',
      border: 'none',
      borderBottom: `1px solid ${theme.searchBarColor || '#e1e1e1'}`,
      background: 'transparent',
      color: theme.cartTextColor,
      fontSize: '14px',
      outline: 'none',
      boxSizing: 'border-box' as const,
    },
    countryOption: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '12px',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease',
    },
    countryOptionHover: {
      backgroundColor: theme.searchBarColor || '#f5f5f5',
    },
    countryName: {
      flex: 1,
      fontSize: '14px',
      color: theme.cartTextColor,
    },
    hint: {
      fontSize: '12px',
      color: theme.cartTextColor,
      opacity: 0.7,
      marginTop: '4px',
    },
    parseHint: {
      fontSize: '12px',
      color: '#10b981',
      marginTop: '4px',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.inputContainer}>
        <div
          style={styles.countrySelector}
          onClick={() => !disabled && setIsDropdownOpen(!isDropdownOpen)}
        >
          {selectedCountry && (
            <>
              <span style={styles.flag}>{selectedCountry.flag}</span>
              <span style={styles.dialCode}>{selectedCountry.dialCode}</span>
              <span style={styles.dropdownArrow}>▼</span>
            </>
          )}
        </div>
        <input
          type="tel"
          value={phoneNumber}
          onChange={handlePhoneNumberChange}
          style={styles.input}
          placeholder={placeholder}
          disabled={disabled}
        />
      </div>
      
      {selectedCountry && (
        <div style={styles.hint}>
          {getHintText(selectedCountry)}
        </div>
      )}

      {/* {showParseHint && (
        <div style={styles.parseHint}>
          ✓ Leading digit(s) automatically removed
        </div>
      )} */}

      {isDropdownOpen && (
        <div style={styles.dropdown}>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={styles.searchInput}
            placeholder="Search countries..."
            autoFocus
          />
          {filteredCountries.map((country) => (
            <div
              key={country.code}
              style={styles.countryOption}
              onClick={() => handleCountrySelect(country)}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = styles.countryOptionHover.backgroundColor;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
              }}
            >
              <span style={styles.flag}>{country.flag}</span>
              <span style={styles.countryName}>{country.name}</span>
              <span style={styles.dialCode}>{country.dialCode}</span>
            </div>
          ))}
          {filteredCountries.length === 0 && (
            <div style={{ padding: '12px', textAlign: 'center', color: theme.cartTextColor, opacity: 0.7 }}>
              No countries found
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PhoneNumberInput;